import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

import { formatInTimezone } from '@/utils/date'
import { useGlobalState } from '@/state'
import useQuery from '@/hooks/useQuery'
import PrimaryButton from '@/shared/Buttons/Primary'
import DefaultButton from '@/shared/Buttons/Default'
import TicketTypes from '@/shared/TicketTypes'
import { Modal, useModal } from '@/shared/Modal'

const WorkoutRow = ({event, user, attendingEventIds, compact}) => {
  const { putpostRequest } = useQuery()
  const [ currentUser ] = useGlobalState('currentUser')
  const [, setToast] = useGlobalState('toast')
  const { openModal, closeModal, isOpen } = useModal()

  const [ attending, setAttending ] = useState(false)
  const [ loading, setLoading ] = useState(false)
  const ticketTypes = event.ticketTypes || {}
  const attendNow = () => { window.location = `/events/links/${event.uuid}` }

  useEffect(() => {
    if (event === null) { return }

  }, [attendingEventIds])

  return <div className="flex flex-col rounded-lg shadow-lg overflow-hidden">
    { !compact && <a href={`/workouts/written/${event.uuid}`} className="flex-shrink-0">
      <div className="aspect-w-16 aspect-h-9">
        <img className="object-cover" src={`${event.imageUrl}?aspect=16:9&width=420`} alt="" />
      </div>
    </a> }
    <a href={`/workouts/written/${event.uuid}`} target="_blank" className="flex-1 bg-clcnavy bg-opacity-10 dark:bg-gray-800 p-2 flex flex-col justify-between">
      <div className="flex-1">
        <p className="text-xl font-semibold text-gray-900 dark:text-gray-200">{event.name}</p>
        <p className="text-sm font-medium text-clcpurple"> <span className='text-gray-500'>{event.lengthOfEvent} min</span> </p>
        <div className="text-clcpurple mt-3">
          { event.status === 'started' && <span>Event has started!</span> }
          { event.status !== 'started' && <time dateTime={event.startsAtUtc}>
            {formatInTimezone(event.startsAtUtc, user.timezone, 'EEE MMMM d, Y h:mmaaa - ')}
            {formatInTimezone(event.endsAtUtc, user.timezone, 'h:mmaaa zzz')}
          </time> }
        </div>
        <div className="block mt-2">
          <p className="mt-3 text-base text-gray-500 line-clamp-3"><span dangerouslySetInnerHTML={{__html: event.description}}></span></p>
        </div>
      </div>
    </a>
  </div>
}

export default WorkoutRow
